module.exports = __webpack_public_path__ + "static/Schwert_Skeletor-37da479d3687265b5e605502b7c0382a.png";